export const DEFAULT_COLLAPSED_HEIGHT = 72
